import React from 'react'
import Navigation from '../components/common/Navigation'
import TermsOfService from '../components/legal/TermsOfService'
import Wave from '../components/common/Wave'
import Social from '../components/common/Social'
import Copyright from '../components/common/Copyright'

function TermsPage() {
  return (
    <>
      <Navigation page="terms"/>
      <TermsOfService />
      <Wave />
      <div className="footer">
        <Social />
        <Copyright />     
      </div>
    </>
  )
}

export default TermsPage

